/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de existencias.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Mejora de distribucion para filtros, tabla y resumen
* ---------------------------------------------------------------------------------------
*/

import FrmExistencias from "../../inventarios/FrmExistencias.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmExistenciasPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmExistencias">
      <FrmExistencias />
    </SizeSoftXFrmPortatil>
  );
}
